import { defineMessages } from 'react-intl';

export default defineMessages({
  securitySettings: {
    id: 'signup_auth_params_security.title',
  },
  myProfile: {
    id: 'my_account.my_profile',
  },
  cin: {
    id: 'my_account.cin',
  },
  birthDay: {
    id: 'signup_personal_info.birthday',
  },
  phoneNumber: {
    id: 'my_account.phone_number',
  },
  email: {
    id: 'id_memo.email',
  },
  changeMyPassword: {
    id: 'my_account.change_my_password',
  },
  changeMySecretQuestion: {
    id: 'my_account.change_my_secret_question',
  },
  notifications: {
    id: 'my_account.notifications',
  },
  activateNotifications: {
    id: 'my_account.activate_notifications',
  },
  languages: {
    id: 'my_account.languages',
  },
  arabic: {
    id: 'my_account.language.arabic',
  },
  french: {
    id: 'my_account.language.french',
  },
  myPreferences: {
    id: 'my_account.my_preferences',
  },
  myPersonalInfo: {
    id: 'my_account.my_personal_info',
  },
  generalConditions: {
    id: 'modal.Title',
  },
  reportABug: {
    id: 'my_account.report_a_bug',
  },
  about: {
    id: 'my_account.about',
  },
  saveChanges: {
    id: 'my_account.save_changes',
  },
  title: {
    id: 'my_account.title',
  },
  subTitle: {
    id: 'Account.subTitle',
  },
  requiredField: {
    id: 'required.field',
  },
  password: {
    id: 'login_page.form.password',
  },
  confirmPasswordTitle: {
    id: 'settings.password_confirm.title',
  },
  confimPasswordSubTitle: {
    id: 'settings.password_confirm.sub_title',
  },
  cancel: {
    id: 'addContract.cancel',
  },
  valid: {
    id: 'recovery_forgot_password.insert_new_password.title_button_valid',
  },
});
